import apis from "../../core/apis.js";

class UniversalResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  search(params) {
    return this.$resource(apis.universal).get(params);
  }
}

export default UniversalResource;



// WEBPACK FOOTER //
// ./src/resources/universal/universal.resource.js